import React__default, { useMemo } from 'react';
import PropTypes from 'prop-types';
import '../../contexts/screen-class-provider/index.js';
import '../../contexts/swan-provider/swan-provider.component.js';
import { swanLoaderConfigProps } from '../../contexts/swan-provider/swan-provider.context.js';
import { MANIFEST_STYLES } from '../../manifest/styles.js';
import { SwanAssetFolders } from '../../types/enums.js';
import { isNonNullish } from '../../utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
const SWAN_STYLE_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_STYLES);
const manifestStylesKeys = Object.keys(MANIFEST_STYLES).filter(u => u !== SWAN_STYLE_KEY_MAP.core && u !== SWAN_STYLE_KEY_MAP.utility);
manifestStylesKeys.unshift(SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.utility);
const SWAN_STYLE_KEY_LIST = manifestStylesKeys;
function getSwanStylesheetUrl(key, pathType, base) {
  return manifestResolve(MANIFEST_STYLES, key, SwanAssetFolders.STYLES, pathType, base);
}
const propTypes = _objectSpread({
  styleSheetKeys: PropTypes.arrayOf(PropTypes.oneOf(SWAN_STYLE_KEY_LIST).isRequired)
}, swanLoaderConfigProps);
const SwanStylesheets = _ref => {
  let {
    styleSheetKeys,
    swanPathType,
    swanBaseUrl,
    swanTenant,
    swanLocale,
    renderWith: Comp = React__default.Fragment
  } = _ref;
  const {
    swanBaseUrl: baseUrl,
    swanPathType: pathType
  } = useSwanHeadConfig(swanBaseUrl, swanPathType, swanTenant, swanLocale);
  const urls = useMemo(() => {
    const deDuplicatedStyleKeys = new Set(styleSheetKeys);
    deDuplicatedStyleKeys.delete(SWAN_STYLE_KEY_MAP.core);
    deDuplicatedStyleKeys.delete(SWAN_STYLE_KEY_MAP.utility);
    const styleKeysList = Array.from(deDuplicatedStyleKeys);
    styleKeysList.sort();
    styleKeysList.unshift(SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.utility);
    const urls = styleKeysList.map(key => getSwanStylesheetUrl(key, pathType, baseUrl));
    const filteredUrls = urls.filter(isNonNullish);
    return filteredUrls;
  }, [styleSheetKeys, pathType, baseUrl]);
  return /*#__PURE__*/React__default.createElement(Comp, null, urls.map(url => /*#__PURE__*/React__default.createElement("link", {
    rel: "stylesheet",
    href: url,
    key: url
  })));
};
SwanStylesheets.defaultProps = {
  styleSheetKeys: SWAN_STYLE_KEY_LIST
};
SwanStylesheets.propTypes = propTypes;
export { SWAN_STYLE_KEY_LIST, SWAN_STYLE_KEY_MAP, SwanStylesheets, getSwanStylesheetUrl };